/* WBU Notify Me v2.8 LIVE - Envy 35; display the server-generated request reference. */
(() => {
  'use strict';
  if (window.__wbuNotifyMeLiveV2) return;
  window.__wbuNotifyMeLiveV2 = true;

  const API = '/apps/wbu-notifyme';
  const busy = new WeakSet();
  const $ = (root, selector) => root && root.querySelector(selector);
  const dataFor = block => {
    try { return JSON.parse($(block, '[data-wbu-notify-variants]').textContent); }
    catch (_) { return []; }
  };
  const chosen = (block) => {
    const section = block.closest('[data-wetheme-section-id]');
    const variants = dataFor(block);
    const byId = new Map(variants.map(v => [String(v.id), v]));
    const urlId = new URLSearchParams(location.search).get('variant');
    if (urlId && byId.has(urlId)) return byId.get(urlId);
    const hidden = section && $(section, 'form[action*="/cart/add"] input[name="id"]');
    if (hidden && byId.has(String(hidden.value))) return byId.get(String(hidden.value));
    return byId.get(block.dataset.wbuDefaultVariantId) || variants[0] || null;
  };
  const labelFor = (block, variant) => {
    if (!variant || variant.title === 'Default Title') return 'Sorry, this item is currently unavailable.';
    const optionName = block.dataset.wbuOptionLabel || '';
    if (/size|taglia/i.test(optionName)) {
      return 'Sorry, ' + (/italian/i.test(optionName) ? 'size IT ' : 'size ') + variant.title + ' is currently unavailable.';
    }
    return 'Sorry, ' + variant.title + ' is currently unavailable.';
  };
  const updateLabel = (block) => {
    const variant = chosen(block);
    const label = $(block, '[data-wbu-notify-availability]');
    if (label && variant && !variant.available) {
      const text = labelFor(block, variant);
      if (label.textContent.trim() !== text) label.textContent = text;
    }
  };
  const showError = (target, message) => {
    if (!target) return;
    target.textContent = message;
    target.hidden = false;
  };
  const clearError = (target) => { if (target) { target.textContent = ''; target.hidden = true; } };
  const requestJSON = async (url, options = {}) => {
    const response = await fetch(url, { credentials:'same-origin', cache:'no-store', ...options, headers: {Accept:'application/json', ...(options.headers || {})}});
    let data;
    try { data = await response.json(); }
    catch (_) { throw new Error('The enquiry service is currently unavailable. Please try again.'); }
    if (!response.ok || !data || !data.ok) {
      const error = new Error(data?.message || 'Unable to complete your request. Please try again.');
      error.code = data?.code || 'unavailable';
      throw error;
    }
    return data;
  };
  const returnTo = (block, variantId) => {
    const url = new URL(block.dataset.wbuProductUrl, location.origin);
    url.searchParams.set('variant', String(variantId));
    url.searchParams.set('wbu_notify', '1');
    return url.pathname + url.search;
  };
  const openLogin = (block, variantId) => {
    location.assign('/customer_authentication/login?return_to=' + encodeURIComponent(returnTo(block, variantId)));
  };
  let activeDialog = null;
  const displayModal = (block, variant, email) => {
    if (activeDialog?.open) activeDialog.close();
    if (activeDialog) activeDialog.remove();
    const template = $(block, '[data-wbu-notify-dialog-template]');
    if (!template) throw new Error('The enquiry form is unavailable.');
    const modal = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(modal);
    activeDialog = modal;
    modal.dataset.productId = block.dataset.wbuProductId;
    modal.dataset.variantId = String(variant.id);
    modal.dataset.accountEmail = email;
    const variantRow = $(modal, '[data-wbu-notify-variant-row]');
    variantRow.hidden = variant.title === 'Default Title';
    if (!variantRow.hidden) $(modal, '[data-wbu-notify-variant]').textContent = variant.title;
    $(modal, '[data-wbu-notify-email]').textContent = email;
    const url = new URL(block.dataset.wbuProductUrl, location.origin);
    url.searchParams.set('variant', String(variant.id));
    $(modal, '[data-wbu-notify-product-link]').href = url.pathname + url.search;
    modal.showModal();
    modal.addEventListener('close', () => { if (activeDialog === modal) activeDialog = null; modal.remove(); }, {once:true});
  };
  const checkAndOpen = async (block, {resume=false}={}) => {
    if (!block || busy.has(block)) return;
    const variant = chosen(block);
    if (!variant || variant.available) return;
    busy.add(block);
    const inlineError = $(block, '[data-wbu-notify-inline-error]');
    const trigger = $(block, '[data-wbu-notify-trigger]');
    clearError(inlineError);
    if (trigger) { trigger.disabled = true; trigger.setAttribute('aria-busy', 'true'); }
    try {
      const result = await requestJSON(API + '?mode=status');
      if (!result.authenticated) {
        if (!resume) openLogin(block, variant.id);
        else showError(inlineError, 'Please sign in to your WBU account and select Notify Me again.');
        return;
      }
      if (typeof result.email !== 'string' || !result.email.includes('@')) throw new Error('Unable to verify your account email.');
      displayModal(block, variant, result.email);
    } catch (error) {
      showError(inlineError, error.message || 'Unable to open the enquiry form.');
    } finally {
      busy.delete(block);
      if (trigger) { trigger.disabled = false; trigger.removeAttribute('aria-busy'); }
    }
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-wbu-notify-trigger]');
    if (trigger) {
      event.preventDefault();
      const block = trigger.closest('[data-wbu-notify-ui]');
      checkAndOpen(block);
      return;
    }
    const close = event.target.closest('[data-wbu-notify-close]');
    if (close) {
      const modal = close.closest('dialog');
      if (modal?.open) modal.close();
      return;
    }
    const submit = event.target.closest('[data-wbu-notify-submit]');
    if (!submit) return;
    const modal = submit.closest('dialog');
    if (!modal || busy.has(modal)) return;
    busy.add(modal);
    submit.disabled = true;
    submit.textContent = 'SENDING...';
    clearError($(modal, '[data-wbu-notify-modal-error]'));
    requestJSON(API + '?mode=submit', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({product_id:modal.dataset.productId, variant_id:modal.dataset.variantId})
    }).then(result => {
      $(modal, '[data-wbu-notify-form-view]').hidden = true;
      $(modal, '[data-wbu-notify-success-view]').hidden = false;
      const ref = $(modal, '[data-wbu-notify-request-ref]');
      if (ref && typeof result.request_id === 'string') {
        // The reference comes from PHP (WBU-DDMMYY-HHMM-XXX), not the browser.
        ref.textContent = 'Request reference: ' + result.request_id.trim();
      }
      if (result.confirmation_pending) {
        const p = $(modal, '[data-wbu-notify-success-view] p');
        if (p) p.textContent = 'Your enquiry was received by Wools Boutique Uomo. We will reply personally. Your confirmation email may be delayed.';
      }
    }).catch(error => {
      showError($(modal, '[data-wbu-notify-modal-error]'), error.message || 'Unable to send your enquiry. Please try again.');
    }).finally(() => {
      busy.delete(modal);
      submit.disabled = false;
      submit.textContent = 'SEND ENQUIRY';
    });
  });
  document.addEventListener('click', event => {
    const modal = event.target.closest('dialog.wbu-notify-dialog');
    if (modal && event.target === modal && modal.open) modal.close();
  });
  document.addEventListener('change', event => {
    const section = event.target.closest('[data-wetheme-section-id]');
    if (!section) return;
    for (const ms of [0, 160, 450]) setTimeout(() => {
      const block = $(section, '[data-wbu-notify-ui]');
      if (block) updateLabel(block);
    }, ms);
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-product-options]')) return;
    const section = event.target.closest('[data-wetheme-section-id]');
    if (!section) return;
    for (const ms of [120, 450]) setTimeout(() => {
      const block = $(section, '[data-wbu-notify-ui]');
      if (block) updateLabel(block);
    }, ms);
  });
  const resume = () => {
    const url = new URL(location.href);
    if (url.searchParams.get('wbu_notify') !== '1') return;
    url.searchParams.delete('wbu_notify');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    const attempt = (n) => {
      const block = document.querySelector('[data-wbu-notify-ui]');
      if (block) checkAndOpen(block, {resume:true});
      else if (n < 6) setTimeout(() => attempt(n+1), 200);
    };
    attempt(0);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resume, {once:true});
  else resume();
})();
